if (!customElements.get('kalzen-product-gallery')) {
  customElements.define('kalzen-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) {
        this.videoBreakpoint?.addEventListener('change', this.onVideoBreakpointChange);
        return;
      }
      this.galleryReady = true;
      this.mainImage = this.querySelector('.kzg__main');
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.status = this.querySelector('[data-gallery-status]');
      this.videoPanels = Array.from(this.querySelectorAll('[data-gallery-video-id]'));
      if (this.videoPanels.length) {
        this.videoBreakpoint = matchMedia('(max-width: 749px)');
        this.onVideoBreakpointChange = () => this.querySelectorAll('video').forEach(video => video.pause());
        this.videoBreakpoint.addEventListener('change', this.onVideoBreakpointChange);
      }
      this.index = 0;
      this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.showMedia(index)));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.showMedia(this.index - 1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.showMedia(this.index + 1));
      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || !this.thumbs.length || event.target.closest('video')) return;
        event.preventDefault();
        this.showMedia(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.thumbs[this.index].focus({ preventScroll: true });
      });
      const stage = this.querySelector('[data-gallery-stage]');
      stage?.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || event.target.closest('button, video')) return;
        this.touchStart = { x: event.clientX, y: event.clientY };
      });
      stage?.addEventListener('pointercancel', () => { this.touchStart = null; });
      stage?.addEventListener('pointerup', (event) => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.showMedia(this.index + (dx < 0 ? 1 : -1));
      });
      if (this.thumbs.length) this.showMedia(0, false);
    }

    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.videoBreakpoint?.removeEventListener('change', this.onVideoBreakpointChange);
    }

    showMedia(index, scroll = true) {
      if (!this.thumbs.length) return;
      this.index = (index + this.thumbs.length) % this.thumbs.length;
      const thumb = this.thumbs[this.index];
      const isVideo = thumb.dataset.galleryMediaType === 'video';
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this.mainImage) this.mainImage.hidden = isVideo;
      this.videoPanels.forEach(panel => {
        panel.hidden = !isVideo || panel.dataset.galleryVideoId !== thumb.dataset.galleryVideoTarget;
      });
      if (!isVideo && this.mainImage?.tagName === 'IMG' && thumb.dataset.imageSrc) {
        const imageWidth = Number(thumb.dataset.imageWidth);
        const imageHeight = Number(thumb.dataset.imageHeight);
        if (imageWidth > 0 && imageHeight > 0) {
          this.mainImage.width = imageWidth;
          this.mainImage.height = imageHeight;
        }
        this.mainImage.srcset = thumb.dataset.imageSrcset || '';
        this.mainImage.src = thumb.dataset.imageSrc;
        this.mainImage.alt = thumb.dataset.imageAlt || '';
        this.mainImage.dataset.galleryView = thumb.dataset.galleryView || 'full';
      }
      this.thumbs.forEach((item, index) => {
        const selected = index === this.index;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      if (this.status) this.status.textContent = `${isVideo ? 'Video' : 'Image'} ${this.index + 1} of ${this.thumbs.length}`;
      if (scroll) {
        const rail = thumb.parentElement;
        const railBox = rail.getBoundingClientRect();
        const thumbBox = thumb.getBoundingClientRect();
        const delta = thumbBox.left < railBox.left ? thumbBox.left - railBox.left : thumbBox.right > railBox.right ? thumbBox.right - railBox.right : 0;
        if (delta) rail.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
  });
}
